import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosIntance,{fetchInstance} from '../../helper/axios'
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import './campaigns.css';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { baseUrl } from '../../config';
import { clickColor, inArray } from './../../library/util';
import Loader from "react-loader-spinner";
function Campaigns() {
  const history = useHistory();
  const [selectedRow, setSelectedRow] = useState(null);
  const [loader, setLoader] = useState(false)
  const [selectedrowList, setSelectedRowList] = useState([]);


  const setRowBackground = (selectedRow) => {
    if (inArray(selectedRow.tableData.id, selectedrowList) == false) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }

  checkUserTypeFn(history);
  const handleSignOut = () => {
    console.log('logout')
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null) {
    history.push('/');
  }
  const [cssCodesData, setcssCodesData] = useState([])
  const [resultCount, setResultCount] = useState(0);
  const [resultCountCounter, setResultCountCounter] = useState(0);

  const [message, setMessage] = useState('')
  const [successMsg, setSuccessMsg] = useState('')
  const data = [['attribute', 'attribute2'], ['value1', 'value2']];

  useEffect(() => {
    setLoader(true)
    axiosIntance.get(baseUrl + '/count/campaigns', {}).then(response => {
      console.log('resultCount=' + response.data.result);
      setResultCount(response.data.result);
      setResultCountCounter(1);
      setLoader(false)
    }).catch(error => {
      console.log(error)
      setMessage('Something went wrong');
    });


    return () => {
      console.log('un subscribe')
    }



  }, [])

  const SubmitDelete = (e) => {

    confirmAlert({
      title: '',
      message: 'Are you sure want to delete All data',
      buttons: [
        {
          label: 'Yes',
          onClick: () =>
            axiosIntance.delete(baseUrl + '/campaigns', {}).then(response => {
              setSuccessMsg('Deleted!')
            }).catch(error => {
              setMessage('Something went wrong');
            })

        },
        {
          label: 'No',
          onClick: () => console.log('No')
        }
      ]
    });
  }
  return (
    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />


      <div className='delete-div'>
        {
          resultCount > 0 ? <button type="button" onClick={SubmitDelete} className="btn btn-primary">Delete All </button> : ''

        }

      </div>
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>


      <section id="content-wrapper">

        {loader &&
          <div className='loaderDiv'>
            <Loader
              type="Circles"
              color="#b4d6fa"
              height={100}
              width={100}
            />
          </div>
        }
        {resultCountCounter > 0 &&

          <MaterialTable
            onRowClick={((evt, selectedRow) =>
              setRowBackground(selectedRow)
            )}


            columns={[
              { title: "product_line", field: "product_line" },
              { title: "campaign_id", field: "campaign_id" },
              { title: "campaign_name", field: "campaign_name" },
              { title: "campaign_group", field: "campaign_group" },
              { title: "campaign_group_second", field: "campaign_group_second" },
              { title: "campaign_group_alltraffic", field: "campaign_group_alltraffic" },
              { title: "group_category", field: "group_category" },
              { title: "payment_type", field: "payment_type" },
              { title: "campaign_status", field: "campaign_status" },
              { title: "quick_note", field: "quick_note" },
              { title: "campaign_classification", field: "campaign_classification" },
              { title: "affiliate_network_tied_to", field: "affiliate_network_tied_to" },
              { title: "cpa_paid_on_campaign", field: "cpa_paid_on_campaign" },
              { title: "ho_offer_ids_tied_to", field: "ho_offer_ids_tied_to" },

              { title: "has_scrub", field: "has_scrub" },
              { title: "which_campaign_id_is_its_scrub", field: "which_campaign_id_is_its_scrub" },
              { title: "is_scrub", field: "is_scrub" },
              { title: "scrub_for_which_campaign_id", field: "scrub_for_which_campaign_id" },
              { title: "scrub_percent", field: "scrub_percent" },

              { title: "scrub_update", field: "scrub_update" },
              { title: "in_house_media", field: "in_house_media" },


            ]}
            data={query =>
              new Promise((resolve, reject) => {
                let url = baseUrl + '/campaigns?'
                url += `&_page=${query.page + 1}`
                url += `&_limit=${query.pageSize}`
                fetchInstance(url)
                  .then(response => response.json())
                  .then(result => {
                    resolve({
                      data: result.result,
                      page: query.page,
                      totalCount: resultCount,
                    })
                  })
              })
            }

            options={{
              sorting: false,
              search: false,
              loadingType: 'overlay',
              maxBodyHeight: '500px',
              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
              })
            }}
            title="Campaigns"
          />
        }


      </section>
    </div>
  )
}

function checkUserTypeFn(history) {
  const userdata = JSON.parse(localStorage.getItem('userdata'));
  const usertype = userdata.type;
  if (usertype != 'admin' && usertype != 'superadmin' && usertype != 'subadmin' && usertype != 'databasehelper' && usertype != 'owneradmin') {
    history.push('/');
  }
}
export default Campaigns
